import { defineComponent, ref, useSlots, computed, createElementBlock, openBlock, mergeProps, createVNode, withCtx, createCommentVNode, createElementVNode, normalizeClass, renderSlot } from 'vue';
import _sfc_main$1 from './basler-components.es129.js';
import { useSlotContent } from './basler-components.es386.js';

const _hoisted_1 = { class: "card__content" };
const _sfc_main = /* @__PURE__ */ defineComponent({
  __name: "Card",
  props: {
    hasLargeGutter: { type: Boolean, default: false },
    headerGutter: { type: Boolean, default: false },
    link: { default: void 0 },
    hasLinkBehavior: { type: Boolean, default: false },
    cardDataAttributes: {}
  },
  setup(__props) {
    const props = __props;
    const footer = ref(null);
    const slots = useSlots();
    const { hasSlotContent } = useSlotContent();
    const hasHeaderSlotContent = computed(() => {
      return hasSlotContent(slots.header);
    });
    const hasFooterSlotContent = computed(() => {
      return hasSlotContent(slots.footer);
    });
    const cardDataAttributesWithPrefix = computed(() => {
      const cardDataAttributes = props.cardDataAttributes ?? {};
      const result = {};
      Object.keys(cardDataAttributes).forEach((key) => {
        result[`data-${key}`] = cardDataAttributes[key];
      });
      return result;
    });
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("article", mergeProps({
        class: ["card", { "card--large-gutter": _ctx.hasLargeGutter }, { "card--has-link": _ctx.link || _ctx.hasLinkBehavior }]
      }, cardDataAttributesWithPrefix.value), [
        createVNode(_sfc_main$1, mergeProps(_ctx.link, { "is-renderless": true }), {
          default: withCtx(() => [
            hasHeaderSlotContent.value ? (openBlock(), createElementBlock("header", {
              key: 0,
              class: normalizeClass(["card__header", { "card__header--with-gutter": _ctx.headerGutter }])
            }, [
              renderSlot(_ctx.$slots, "header")
            ], 2)) : createCommentVNode("", true),
            createElementVNode("div", _hoisted_1, [
              renderSlot(_ctx.$slots, "default")
            ]),
            hasFooterSlotContent.value ? (openBlock(), createElementBlock("footer", {
              key: 1,
              ref_key: "footer",
              ref: footer,
              class: "card__footer"
            }, [
              renderSlot(_ctx.$slots, "footer")
            ], 512)) : createCommentVNode("", true)
          ]),
          _: 3
        }, 16)
      ], 16);
    };
  }
});

export { _sfc_main as default };
